import React, { useEffect } from 'react'
import {
  Button,
  Card,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Typography
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';

export const ObraDiarioModalEquipe = ({ modal, toggle, props, equipe }) => {

  const { classes, className, ...rest } = props
  const { match: { params } } = props;

  const handleClose = () => {
    toggle();
  }

  return (
    <Dialog
      open={modal}
      fullWidth
      style={{ padding: 0, margin: 0 }}
      maxWidth='md'
      onClose={toggle}
    >
      <DialogTitle>
        <Grid alignItems="flex-end" container justifyContent="space-between" spacing={3}>
          <Grid item>
            <Typography style={{ fontSize: "16px", fontWeight: 'bold', textAlign: "left", marginRight: 5 }}>
              EQUIPE
            </Typography>
          </Grid>
          <Button
            variant="contained"
            size="small"
            style={{ backgroundColor: '#000', position: 'relative', marginTop: 15 }}
            onClick={() => handleClose()}>
            <CloseIcon />
          </Button>
        </Grid>
      </DialogTitle>
      <DialogContent style={{ padding: 0, margin: 0 }}>
        <Card style={{ marginTop: 0, paddingLeft: 8, paddingRight: 8, paddingBottom: 8 }}>
          <Table fullWidth>
            <Table size="small" fullWidth>
              <TableHead>
                <TableRow key={0}>
                  <TableCell>
                    Nome
                  </TableCell>
                  <TableCell>
                    Cargo
                  </TableCell>
                </TableRow>
              </TableHead>
              {equipe && equipe.length > 0 && equipe.map((item) => (
                <TableBody>
                  <TableRow key={item.nome}>
                    <TableCell align="left" style={{ fontSize: 10, verticalAlign: 'middle' }}>
                      <span>{item.usuario}</span>
                    </TableCell>
                    <TableCell align="left" style={{ fontSize: 10, verticalAlign: 'middle' }}>
                      <span>{item.cargo}</span>
                    </TableCell>
                  </TableRow>
                </TableBody>
              ))}
            </Table>
          </Table>
        </Card >
      </DialogContent >
    </Dialog >
  )
}
